module.exports = __webpack_public_path__ + "static/media/login-mobile-header.effd2d1a.svg";